const getBundleName = ({bundles, bundle}) =>
  [...bundles].find((existingBundle) => existingBundle.bundle === bundle)
    ?.name || bundle;

export default getBundleName;
